/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ==========================================================================
   佐渡汽船オンラインストア: レイジクリック防止＆カート追加ローディング演出
   ========================================================================== */
(function() {
  var isSubmitting = false;

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-action="add-to-cart"], .product-form__add-button');
    if (!btn) return;

    // すでに処理中の場合は二重タップ・連打を遮断
    if (isSubmitting || btn.classList.contains('is-loading') || btn.disabled) {
      if (isSubmitting) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
      return;
    }

    isSubmitting = true;
    btn.classList.add('is-loading');

    // ボタンにスピナーと追加中テキストを一時付与（視覚的フィードバック）
    if (!btn.getAttribute('data-original-html')) {
      btn.setAttribute('data-original-html', btn.innerHTML);
    }
    btn.style.minWidth = btn.offsetWidth + 'px';
    btn.innerHTML = '<span class="sk-button-spinner"></span> 追加中...';

    // セーフティタイマー（万が一ネットワークやテーマ側でイベントが拾えなかった場合の復帰）
    var resetTimer = setTimeout(function() {
      resetButton(btn);
    }, 4000);

    function onComplete() {
      clearTimeout(resetTimer);
      resetButton(btn);
      document.removeEventListener('theme:loading:end', onComplete);
      document.removeEventListener('product:added', onComplete);
    }

    document.addEventListener('theme:loading:end', onComplete, { once: true });
    document.addEventListener('product:added', onComplete, { once: true });
  }, true);

  function resetButton(btn) {
    isSubmitting = false;
    if (!btn) return;
    btn.classList.remove('is-loading');
    var original = btn.getAttribute('data-original-html');
    if (original) {
      btn.innerHTML = original;
    }
    btn.removeAttribute('disabled');
  }
})();

